import { ProfileDialog } from '@strata/react-dialog';
import { DetailLabelValuePair } from '@strata/react-label-value-pairs';
import { SuccessToast } from '@strata/react-toast-message';

import { useGetUserProfileQuery, usePutUserProfileMutation } from 'store/api/authApi';

interface UserProfileDialogProps {
    isOpen: boolean;
    onSecondaryButtonClick: () => void;
}

export const UserProfileDialog = ({ isOpen, onSecondaryButtonClick }: UserProfileDialogProps) => {
    const { data: profile, isFetching: isProfileFetching } = useGetUserProfileQuery();
    const [putUserProfile] = usePutUserProfileMutation();

    return (
        <ProfileDialog
            isOpen={isOpen}
            isLoading={isProfileFetching}
            onSecondaryButtonClick={onSecondaryButtonClick}
            onSubmit={async (values) => {
                await putUserProfile(values).unwrap();
                SuccessToast({ message: 'Your profile was updated successfully.' });
                onSecondaryButtonClick();
            }}
            userFullName={profile?.fullName}
            userEmailAddress={profile?.email}
            additionalDialogContent={<DetailLabelValuePair label="Role" value={profile?.role} />}
        />
    );
};
